import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsFillTrash3Fill } from "react-icons/bs";

function DeleteInstructorConfirmation({ onDeleteConfirm, instructor }: any) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    onDeleteConfirm(instructor.user_id);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <BsFillTrash3Fill
        style={{ color: "darkred", cursor: "pointer" }}
        onClick={() => {
          handleDeleteClick();
        }}
        title={"Obriši nastavnika"}
      />

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potvrdi brisanje nastavnika</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Jeste li sigurni da želite obrisati nastavnika{" "}
          <strong>
            {instructor.first_name} {instructor.last_name}
          </strong>
          ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Odustani
          </Button>
          <Button onClick={handleConfirm}>Obriši</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteInstructorConfirmation;
